export default "assets/images/92fdb6241a89847fb29c32758753eb5c.png";